module.exports = __webpack_public_path__ + "img/Language.476016fa.svg";